import { useEffect, useState, useContext } from 'react';
import { Button, Box, Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MiSelect from '../../componentes/formulario/MiSelect';
import FormRow from '../../componentes/formulario/FormRow';
import Form from 'react-bootstrap/Form';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { getApiUrl, getDecodedCookie } from '../../helpers/helperApp';
import { alertService } from '../../services/alertservice';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    infoBox: {
        backgroundColor: '#f5f5f5',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        fontSize: '0.875rem',
    },
    dangerBox: {
        backgroundColor: '#f18282',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        fontSize: '0.875rem',
    },
    warningBox: {
        backgroundColor: '#fff3cd',
        color: '#664d03',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        fontSize: '0.875rem',
        border: '1px solid #ffc107',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ['Número de Firmas Requeridas', 'Definición de Firmantes', 'Configuración de Notificaciones'];
}

function Signs(props) {
    const { onLoading, stepId, formularioPrinId, formularioHijo, cicloId } = props;
    const [hasSign, setHasSign] = useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [numSignatures, setNumSignatures] = useState(1);
    const [agentTypes, setAgentTypes] = useState([]);
    const [dataAgentTypes, setDataAgentTypes] = useState([]);
    const [agents, setAgents] = useState([]);
    const [sendEmail, setSendEmail] = useState([]);
    const [attachDocuments, setAttachDocuments] = useState([]);
    const [openCollapsibles, setOpenCollapsibles] = useState([false, false, false]);
    const [documentsSuccess, setDocumentsSuccess] = useState([]);
    const [emailSuccess, setEmailSuccess] = useState('');
    const [ccSuccess, setCcSuccess] = useState('');
    const [documentsFailed, setDocumentsFailed] = useState([]);
    const [emailFailed, setEmailFailed] = useState('');
    const [ccFailed, setCcFailed] = useState('');
    const [documentsModify, setDocumentsModify] = useState([]);
    const [emailModify, setEmailModify] = useState('');
    const [ccModify, setCcModify] = useState('');
    const [step2Warning, setStep2Warning] = useState('');
    const [step3Warning, setStep3Warning] = useState('');
    const [step2Attempted, setStep2Attempted] = useState(false);
    const [agentsData, setAgentsData] = useState([]);
    const [isAgentsLoading, setIsAgentsLoading] = useState([]);
    const [hadSignsLoaded, setHadSignsLoaded] = useState(false);
    const [pendingDisableSave, setPendingDisableSave] = useState(false);
    const [loadedSignIds, setLoadedSignIds] = useState([]);

    const steps = getSteps();

    const resetSignsState = ({ preserveDisableMeta = false, preservePendingDisableSave = false } = {}) => {
        setHasSign(false);
        setActiveStep(0);
        setNumSignatures(1);
        setAgentTypes([]);
        setAgents([]);
        setSendEmail([]);
        setAttachDocuments([]);
        setOpenCollapsibles([false, false, false]);
        setDocumentsSuccess([]);
        setEmailSuccess('');
        setCcSuccess('');
        setDocumentsFailed([]);
        setEmailFailed('');
        setCcFailed('');
        setDocumentsModify([]);
        setEmailModify('');
        setCcModify('');
        setStep2Attempted(false);
        setStep2Warning('');
        setStep3Warning('');
        if (!preservePendingDisableSave) {
            setPendingDisableSave(false);
        }
        if (!preserveDisableMeta) {
            setHadSignsLoaded(false);
            setLoadedSignIds([]);
        }
    };

    const { apiKey: apiKeyContext } = useContext(LoginContext);
    const apiKey = () => {
        const cookies = new Cookies();
        const idSesion = getDecodedCookie('sesion');
        const sesion = getDecodedCookie('id');
        const validacion = { "sesion": idSesion, "id": sesion };
        return JSON.stringify(validacion);
    };

    const safeJsonArray = (value, fallback = []) => {
        if (Array.isArray(value)) return value;
        if (typeof value !== 'string' || value.trim() === '') return fallback;
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : fallback;
        } catch (error) {
            return fallback;
        }
    };

    useEffect(() => {
        resetSignsState();
    }, [formularioPrinId]);

    useEffect(() => {
        const adjustArray = (arr, length, defaultVal) => {
            const newArr = arr.slice(0, length);
            while (newArr.length < length) {
                newArr.push(defaultVal);
            }
            return newArr;
        };

        setAgentTypes(prev => adjustArray(prev, numSignatures, null));
        setAgents(prev => adjustArray(prev, numSignatures, []));
        setAgentsData(prev => adjustArray(prev, numSignatures, []));
        setIsAgentsLoading(prev => adjustArray(prev, numSignatures, false));
    }, [numSignatures]);

    useEffect(() => {
        const loadSavedSignatures = async () => {
            if (!stepId || stepId === 0) return;

            try {
                const data = new FormData();
                data.append("validacion", apiKey());
                data.append("docId", stepId);

                const url = `${getApiUrl(window.location.origin)}/Signs/getSignsById`;
                const response = await axios.post(url, data);

                if (response.data && response.data.success) {
                    const savedData = response.data.data || {};
                    const signs = Array.isArray(savedData.signs) ? savedData.signs : [];
                    const notifications = Array.isArray(savedData.notifications) ? savedData.notifications : [];

                    if (signs.length === 0) {
                        resetSignsState();
                        return;
                    }

                    setHadSignsLoaded(true);
                    setPendingDisableSave(false);
                    setLoadedSignIds(
                        signs
                            .map((sign) => sign?.id)
                            .filter((id) => id !== null && id !== undefined && id !== '')
                            .map((id) => String(id))
                    );
                    setHasSign(true);
                    setActiveStep(0);

                    const totalSignatures = Number(signs[0]?.sign_count) || signs.length || 1;
                    setNumSignatures(totalSignatures);

                    const normalizedSigns = Array.from({ length: totalSignatures }, (_, idx) => signs[idx] || {});

                    const newAgentTypes = normalizedSigns.map((sign) => (
                        sign.agent_type !== null && sign.agent_type !== undefined && sign.agent_type !== ''
                            ? String(sign.agent_type)
                            : null
                    ));
                    const newAgents = normalizedSigns.map((sign) => (
                        safeJsonArray(sign.agents_group, []).map((agentId) => String(agentId))
                    ));
                    const newSendEmail = normalizedSigns.map((sign) => String(sign.send_mail) === '1');
                    const newAttachDocuments = normalizedSigns.map((sign) => String(sign.send_doc) === '1');

                    setAgentTypes(newAgentTypes);
                    setAgents(newAgents);
                    setSendEmail(newSendEmail);
                    setAttachDocuments(newAttachDocuments);

                    const agentsDataResults = await Promise.all(
                        newAgentTypes.map((agentType, idx) => (
                            agentType ? fetchAgents(agentType, idx) : Promise.resolve([])
                        ))
                    );
                    setAgentsData(agentsDataResults);

                    const nextOpenCollapsibles = [false, false, false];
                    let nextEmailSuccess = '';
                    let nextCcSuccess = '';
                    let nextDocumentsSuccess = [];
                    let nextEmailFailed = '';
                    let nextCcFailed = '';
                    let nextDocumentsFailed = [];
                    let nextEmailModify = '';
                    let nextCcModify = '';
                    let nextDocumentsModify = [];

                    notifications.forEach((notification) => {
                        const statusId = String(notification?.status_id || '');
                        const statusName = String(notification?.status_name || '').toUpperCase();
                        const docs = safeJsonArray(notification?.case_docs, []).map((docId) => String(docId));

                        if (statusId === '6' || statusName === 'ACEPTADO') {
                            nextOpenCollapsibles[0] = true;
                            nextEmailSuccess = notification?.email || '';
                            nextCcSuccess = notification?.email_cc || '';
                            nextDocumentsSuccess = docs;
                            return;
                        }

                        if (statusId === '7' || statusName === 'RECHAZADO') {
                            nextOpenCollapsibles[1] = true;
                            nextEmailFailed = notification?.email || '';
                            nextCcFailed = notification?.email_cc || '';
                            nextDocumentsFailed = docs;
                            return;
                        }

                        if (statusId === '8' || statusName === 'MODIFICADO' || statusName === 'MODIFICACION') {
                            nextOpenCollapsibles[2] = true;
                            nextEmailModify = notification?.email || '';
                            nextCcModify = notification?.email_cc || '';
                            nextDocumentsModify = docs;
                        }
                    });

                    setOpenCollapsibles(nextOpenCollapsibles);
                    setEmailSuccess(nextEmailSuccess);
                    setCcSuccess(nextCcSuccess);
                    setDocumentsSuccess(nextDocumentsSuccess);
                    setEmailFailed(nextEmailFailed);
                    setCcFailed(nextCcFailed);
                    setDocumentsFailed(nextDocumentsFailed);
                    setEmailModify(nextEmailModify);
                    setCcModify(nextCcModify);
                    setDocumentsModify(nextDocumentsModify);
                }
            } catch (error) {
                console.error('Error loading saved signatures:', error);
            }
        };

        loadSavedSignatures();
    }, [stepId]);

    useEffect(() => {
        const cargarAgentes = async () => {
            try {
                const data = new FormData();
                data.append("validacion", apiKey());
                const url = `${getApiUrl(window.location.origin)}/Agentes/getTipAge`;
                const response = await axios.post(url, data);
                const agentes = response.data.data.map(agente => ({
                    value: agente.value,
                    label: agente.label
                }));
                setDataAgentTypes(agentes);
            } catch (error) {
                console.error('Error cargando agentes:', error);
            }
        };
        cargarAgentes();
    }, [hasSign]);

    const handleCollapseChange = (index) => {
        const newOpenCollapsibles = [...openCollapsibles];
        newOpenCollapsibles[index] = !newOpenCollapsibles[index];
        setOpenCollapsibles(newOpenCollapsibles);
    };

    const isValidEmail = (email) => {
        if (!email || email.trim() === '') return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div>
                        <MiSelect
                            estadoForm={"enabled"}
                            val={numSignatures}
                            loading={onLoading}
                            id={"num_signatures"}
                            name={"num_signatures"}
                            label={"Número de firmas"}
                            formulario={stepId}
                            placeholder={"Seleccione un número"}
                            col={4}
                            isClearable={false}
                            isSearchable={false}
                            dataType={"codigo"}
                            data={[{ value: 1, label: "1" }, { value: 2, label: "2" }, { value: 3, label: "3" }]}
                            required={true}
                            change={(option) => setNumSignatures(option.value)}
                        />
                        <div className={classes.infoBox}>
                            {!hasSign
                                ? 'Sin firma requerida. Los pedidos serán aprobados automáticamente al marcarse como listos.'
                                : `El pedido requerirá ${numSignatures} firma(s). El proceso avanzará al proveedor una vez firmado.`
                            }
                        </div>
                    </div>
                );
            case 1:
                const showStep2Errors = step2Attempted && numSignatures > 0;
                return (
                    <Box>
                        <Form.Label>{steps[step]}</Form.Label>
                        <p>Por favor, introduzca el detalle para la(s) {numSignatures} firma(s):</p>
                        {[...Array(numSignatures)].map((_, index) => {
                            const hasError = showStep2Errors && !agentTypes[index];
                            return (
                            <div 
                                className={`card mb-3 ${hasError ? 'border-danger' : ''}`} 
                                key={index}
                            >
                                <div className={`card-header ${hasError ? 'bg-danger text-white' : ''}`}>
                                    <h5 className="mb-0" style={{ fontSize: '1rem' }}>
                                        Firma {index + 1}
                                        {hasError && <i className="fal fa-exclamation-circle ml-2"></i>}
                                    </h5>
                                </div>
                                <div className="card-body">
                                    <FormRow>
                                        <MiSelect
                                            estadoForm={"enabled"}
                                            val={agentTypes[index] || null}
                                            loading={onLoading}
                                            id={`agent_type_${index}`}
                                            name={`agent_type_${index}`}
                                            label={`Firma de tipo de agente ${index + 1}`}
                                            formulario={stepId}
                                            placeholder={`Seleccione un tipo de agente`}
                                            col={4}
                                            isClearable={true}
                                            isSearchable={true}
                                            dataType={"codigo"}
                                            data={dataAgentTypes}
                                            required={true}
                                            change={async (option) => {
                                                const selectedValue = option?.value ?? null;
                                                const currentIndex = index;

                                                const normalize = (v) => (v === null || v === undefined ? null : String(v));

                                                const selectedNorm = normalize(selectedValue);

                                                if (selectedNorm) {
                                                    setStep2Warning('');
                                                    setStep2Attempted(false);
                                                }

                                                let newAgentTypes = [...agentTypes];
                                                let newAgents = [...agents];
                                                let newAgentsData = [...agentsData];

                                                newAgentTypes[currentIndex] = selectedNorm;
                                                newAgents[currentIndex] = [];
                                                newAgentsData[currentIndex] = [];

                                                if (selectedNorm) {
                                                    const fetchedAgents = await fetchAgents(selectedNorm, currentIndex);
                                                    newAgentsData[currentIndex] = fetchedAgents;
                                                }

                                                setAgentTypes(newAgentTypes);
                                                setAgents(newAgents);
                                                setAgentsData(newAgentsData);
                                            }}
                                        >
                                        </MiSelect>

                                        <MiSelect
                                            estadoForm={"enabled"}
                                            val={agents[index] || []}
                                            loading={isAgentsLoading[index] || onLoading}
                                            id={`agent_${index}`}
                                            name={`agent_${index}`}
                                            label={`Firma de agente/s ${index + 1}`}
                                            formulario={stepId}
                                            placeholder={`Seleccione un agente o varios`}
                                            col={4}
                                            isClearable={true}
                                            isSearchable={true}
                                            isMulti={true}
                                            dataType={"codigo"}
                                            disabled={!agentTypes[index]}
                                            data={agentsData[index] || []}
                                            required={true}
                                            change={(options) => {
                                                const newAgents = [...agents];
                                                newAgents[index] = Array.isArray(options) ? options.map(opt => opt.value) : [];
                                                setAgents(newAgents);
                                            }}
                                        >
                                        </MiSelect>

                                        <div className="col-md-2 d-flex align-items-center">
                                            <div className='form-group col-md-8'>
                                                <Form.Label
                                                    className="mr-2 mb-0"
                                                >
                                                    Enviar correo
                                                </Form.Label>

                                                <input
                                                    id={`send_email_${index}`}
                                                    className="apple-switch"
                                                    type="checkbox"
                                                    checked={sendEmail[index] || false}
                                                    onChange={(e) => {
                                                        const newSendEmail = [...sendEmail];
                                                        newSendEmail[index] = e.target.checked;
                                                        setSendEmail(newSendEmail);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-2 d-flex align-items-center">
                                            <div className='form-group col-md-8'>
                                                < Form.Label
                                                    className="mr-2 mb-0 "
                                                >
                                                    Adjuntar docs
                                                </Form.Label>
                                                <input
                                                    id={`attach_documents_${index}`}
                                                    className="apple-switch"
                                                    type="checkbox"
                                                    checked={(attachDocuments[index] || false) && sendEmail[index]}
                                                    disabled={!sendEmail[index]}
                                                    onChange={(e) => {
                                                        const newAttachDocuments = [...attachDocuments];
                                                        newAttachDocuments[index] = e.target.checked;
                                                        setAttachDocuments(newAttachDocuments);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </FormRow>
                                </div>
                            </div>
                            );
                        })}
                        {step2Warning && <div className={classes.warningBox}>{step2Warning}</div>}
                    </Box>
                );
            case 2:
                return (
                    <div>
                        <label>{steps[step]}</label>

                        {step3Warning && <div className={classes.warningBox}>{step3Warning}</div>}

                        <div>
                            <div className="card mb-3" style={{ borderLeft: '4px solid #28a745' }}>
                                <div className="card-header bg-white d-flex align-items-center">
                                    <h5 className="mb-0 text-dark" style={{ fontSize: '1rem' }}>
                                        <i className="fal fa-badge-check mr-2 text-success"></i> Notificación final a Compras: al completar todas las firmas
                                    </h5>
                                    <div className="ml-auto pl-3">
                                        <input
                                            className="apple-switch"
                                            type="checkbox"
                                            checked={openCollapsibles[0]}
                                            onChange={() => handleCollapseChange(0)}
                                        />
                                    </div>
                                </div>
                                <div className={`collapse ${openCollapsibles[0] ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <FormRow>
                                            <div className="form-group col-md-6">
                                                <Form.Label>Destinatario (Buzón de compras)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="email@empresa.com"
                                                    value={emailSuccess}
                                                    onChange={(e) => setEmailSuccess(e.target.value)}
                                                    isInvalid={emailSuccess && !isValidEmail(emailSuccess)}
                                                    autoComplete="off"
                                                />
                                                {emailSuccess && !isValidEmail(emailSuccess) && (
                                                    <Form.Text className="text-danger">
                                                        Formato de email inválido
                                                    </Form.Text>
                                                )}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <Form.Label>CC Adicional (Opcional)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="otro@empresa.com"
                                                    value={ccSuccess}
                                                    onChange={(e) => setCcSuccess(e.target.value)}
                                                    isInvalid={ccSuccess && !isValidEmail(ccSuccess)}
                                                    autoComplete="off"
                                                />
                                                {ccSuccess && !isValidEmail(ccSuccess) && (
                                                    <Form.Text className="text-danger">
                                                        Formato de email inválido
                                                    </Form.Text>
                                                )}
                                            </div>
                                        </FormRow>
                                        <FormRow>
                                            <MiSelect
                                                estadoForm={"enabled"}
                                                val={documentsSuccess}
                                                loading={onLoading}
                                                id={`documentSuccess`}
                                                name={`documentSuccess`}
                                                label={`Documentos adjuntos`}
                                                formulario={stepId}
                                                placeholder={`Seleccione uno o varios documentos`}
                                                col={4}
                                                isClearable={true}
                                                isSearchable={true}
                                                isMulti={true}
                                                dataType={"codigo"}
                                                data={[{ value: "1", label: "Comparativa de ofertas" }, { value: "2", label: "Confirmación de pedido" }, { value: "3", label: "Orden de compra" }]}
                                                required={true}
                                                change={(options) => {
                                                    const newDocuments = Array.isArray(options) ? options.map(opt => opt.value) : [];
                                                    setDocumentsSuccess(newDocuments);
                                                }}
                                            >
                                            </MiSelect>
                                        </FormRow>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-3" style={{ borderLeft: '4px solid #dc3545' }}>
                                <div className="card-header bg-white d-flex align-items-center">
                                    <h5 className="mb-0 text-dark" style={{ fontSize: '1rem' }}>
                                        <i className="fal fa-xmark mr-2 text-danger"></i> Notificación final a Compras: en caso de rechazo
                                    </h5>
                                    <div className="ml-auto pl-3">
                                        <input
                                            className="apple-switch"
                                            type="checkbox"
                                            checked={openCollapsibles[1]}
                                            onChange={() => handleCollapseChange(1)}
                                        />
                                    </div>
                                </div>
                                <div className={`collapse ${openCollapsibles[1] ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <FormRow>
                                            <div className="form-group col-md-6">
                                                <Form.Label>Destinatario (Buzón de compras)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="email@empresa.com"
                                                    value={emailFailed}
                                                    onChange={(e) => setEmailFailed(e.target.value)}
                                                    isInvalid={emailFailed && !isValidEmail(emailFailed)}
                                                    autoComplete="off"
                                                />
                                                {emailFailed && !isValidEmail(emailFailed) && (
                                                    <Form.Text className="text-danger">
                                                        Formato de email inválido
                                                    </Form.Text>
                                                )}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <Form.Label>CC Adicional (Opcional)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="otro@empresa.com"
                                                    value={ccFailed}
                                                    onChange={(e) => setCcFailed(e.target.value)}
                                                    isInvalid={ccFailed && !isValidEmail(ccFailed)}
                                                    autoComplete="off"
                                                />
                                                {ccFailed && !isValidEmail(ccFailed) && (
                                                    <Form.Text className="text-danger">
                                                        Formato de email inválido
                                                    </Form.Text>
                                                )}
                                            </div>
                                        </FormRow>
                                        <FormRow>
                                            <MiSelect
                                                estadoForm={"enabled"}
                                                val={documentsFailed}
                                                loading={onLoading}
                                                id={`documentFailed`}
                                                name={`documentFailed`}
                                                label={`Documentos adjuntos`}
                                                formulario={stepId}
                                                placeholder={`Seleccione uno o varios documentos`}
                                                col={4}
                                                isClearable={true}
                                                isSearchable={true}
                                                isMulti={true}
                                                dataType={"codigo"}
                                                data={[{ value: "1", label: "Comparativa de ofertas" }, { value: "2", label: "Confirmación de pedido" }, { value: "3", label: "Orden de compra" }]}
                                                required={true}
                                                change={(options) => {
                                                    const newDocuments = Array.isArray(options) ? options.map(opt => opt.value) : [];
                                                    setDocumentsFailed(newDocuments);
                                                }}
                                            >
                                            </MiSelect>
                                        </FormRow>
                                        <FormRow>
                                            <div className={classes.dangerBox}>
                                                <i className='fal fa-exclamation text-danger'></i>
                                                El correo incluirá automáticamente el motivo del rechazo, el usuario que lo realizó, la fecha y hora, y los datos del pedido.
                                            </div>
                                        </FormRow>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-3" style={{ borderLeft: '4px solid #ffc107' }}>
                                <div className="card-header bg-white d-flex align-items-center">
                                    <h5 className="mb-0 text-dark" style={{ fontSize: '1rem' }}>
                                        <i className="fal fa-pencil mr-2 text-warning"></i> Notificación final a Compras: en caso de modificación directa
                                    </h5>
                                    <div className="ml-auto pl-3">
                                        <input
                                            className="apple-switch"
                                            type="checkbox"
                                            checked={openCollapsibles[2]}
                                            onChange={() => handleCollapseChange(2)}
                                        />
                                    </div>
                                </div>
                                <div className={`collapse ${openCollapsibles[2] ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <FormRow>
                                            <div className="form-group col-md-6">
                                                <Form.Label>Destinatario (Buzón de compras)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="email@empresa.com"
                                                    value={emailModify}
                                                    onChange={(e) => setEmailModify(e.target.value)}
                                                    isInvalid={emailModify && !isValidEmail(emailModify)}
                                                    autoComplete="off"
                                                />
                                                {emailModify && !isValidEmail(emailModify) && (
                                                    <Form.Text className="text-danger">
                                                        Formato de email inválido
                                                    </Form.Text>
                                                )}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <Form.Label>CC Adicional (Opcional)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="otro@empresa.com"
                                                    value={ccModify}
                                                    onChange={(e) => setCcModify(e.target.value)}
                                                    isInvalid={ccModify && !isValidEmail(ccModify)}
                                                    autoComplete="off"
                                                />
                                                {ccModify && !isValidEmail(ccModify) && (
                                                    <Form.Text className="text-danger">
                                                        Formato de email inválido
                                                    </Form.Text>
                                                )}
                                            </div>
                                        </FormRow>
                                        <FormRow>
                                            <MiSelect
                                                estadoForm={"enabled"}
                                                val={documentsModify}
                                                loading={onLoading}
                                                id={`documentModify`}
                                                name={`documentModify`}
                                                label={`Documentos adjuntos`}
                                                formulario={stepId}
                                                placeholder={`Seleccione uno o varios documentos`}
                                                col={4}
                                                isClearable={true}
                                                isSearchable={true}
                                                isMulti={true}
                                                dataType={"codigo"}
                                                data={[{ value: "1", label: "Comparativa de ofertas" }, { value: "2", label: "Confirmación de pedido" }, { value: "3", label: "Orden de compra" }]}
                                                required={true}
                                                change={(options) => {
                                                    const newDocuments = Array.isArray(options) ? options.map(opt => opt.value) : [];
                                                    setDocumentsModify(newDocuments);
                                                }}
                                            >
                                            </MiSelect>
                                        </FormRow>
                                        <FormRow>
                                            <div className={classes.warningBox}>
                                                <i className='fal fa-exclamation text-warning'></i>
                                                El correo incluirá automáticamente el motivo de la modificación, el usuario que la realizó, la fecha y hora, y los datos del pedido. Las firmas anteriores quedarán invalidadas.
                                            </div>
                                        </FormRow>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                );
            default:
                return 'Paso desconocido';
        }
    }

    const fetchAgents = async (typeId, index) => {
        const newIsAgentsLoading = [...isAgentsLoading];
        newIsAgentsLoading[index] = true;
        setIsAgentsLoading(newIsAgentsLoading);

        try {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("agent_type_id", typeId);

            const url = `${getApiUrl(window.location.origin)}/Agentes/getAgentsByTypeId`;
            const response = await axios.post(url, data);

            if (response.data && response.data.data) {
                return response.data.data.map(agent => ({
                    value: agent.value,
                    label: agent.label,
                }));
            }
            console.error("Failed to fetch agents: Invalid response format");
            return [];
        } catch (error) {
            console.error("Error fetching agents:", error);
            return [];
        } finally {
            const finalIsAgentsLoading = [...isAgentsLoading];
            finalIsAgentsLoading[index] = false;
            setIsAgentsLoading(finalIsAgentsLoading);
        }
    };

    const handleNext = () => {
        // --- Validation for Step 2 (content of index 1) ---
        if (activeStep === 1) {
            setStep2Attempted(true);
            const isAnyAgentTypeSelected = agentTypes.some(type => type);
            if (numSignatures > 0 && !isAnyAgentTypeSelected) {
                setStep2Warning('Aviso: No ha seleccionado un tipo de agente para ninguna de las firmas. Se procederá sin esta configuración.');
            } else {
                setStep2Warning('');
                setStep2Attempted(false);
            }
        }

        // --- "Finalizar" action ---
        if (activeStep === steps.length - 1) {
            // --- Validation for Step 3 (content of index 2) ---
            const validationMessages = [];
            const invalidEmailMessages = [];

            if (openCollapsibles[0] && !emailSuccess) {
                validationMessages.push('Notificación de firmas completadas');
            } else if (openCollapsibles[0] && emailSuccess && !isValidEmail(emailSuccess)) {
                invalidEmailMessages.push('Notificación de firmas completadas');
            }
            if (openCollapsibles[0] && ccSuccess && !isValidEmail(ccSuccess)) {
                invalidEmailMessages.push('CC de notificaciones completadas');
            }

            if (openCollapsibles[1] && !emailFailed) {
                validationMessages.push('Notificación de rechazo');
            } else if (openCollapsibles[1] && emailFailed && !isValidEmail(emailFailed)) {
                invalidEmailMessages.push('Notificación de rechazo');
            }
            if (openCollapsibles[1] && ccFailed && !isValidEmail(ccFailed)) {
                invalidEmailMessages.push('CC de notificaciones de rechazo');
            }

            if (openCollapsibles[2] && !emailModify) {
                validationMessages.push('Notificación de modificación');
            } else if (openCollapsibles[2] && emailModify && !isValidEmail(emailModify)) {
                invalidEmailMessages.push('Notificación de modificación');
            }
            if (openCollapsibles[2] && ccModify && !isValidEmail(ccModify)) {
                invalidEmailMessages.push('CC de notificaciones de modificación');
            }

            if (invalidEmailMessages.length > 0) {
                setStep3Warning(`Error: Los siguientes emails tienen un formato inválido: ${invalidEmailMessages.join(', ')}.`);
                return;
            }

            if (validationMessages.length > 0) {
                setStep3Warning(`Aviso: Ha habilitado las siguientes notificaciones sin especificar un destinatario: ${validationMessages.join(', ')}. Se guardará la configuración sin estos destinatarios.`);
            } else {
                setStep3Warning(''); // Clear warning if validation passes
            }

            // Gather all data and "save"
            const finalConfiguration = {
                hasSign,
                numSignatures,
                signatures: [...Array(numSignatures)].map((_, index) => ({
                    agentType: agentTypes[index] || null,
                    agents: agents[index] || [],
                    sendEmail: sendEmail[index] || false,
                    attachDocuments: attachDocuments[index] || false,
                })),
                notifications: {
                    onSuccess: {
                        enabled: openCollapsibles[0],
                        emailTo: emailSuccess,
                        cc: ccSuccess,
                        documents: documentsSuccess,
                    },
                    onFailure: {
                        enabled: openCollapsibles[1],
                        emailTo: emailFailed,
                        cc: ccFailed,
                        documents: documentsFailed,
                    },
                    onModify: {
                        enabled: openCollapsibles[2],
                        emailTo: emailModify,
                        cc: ccModify,
                        documents: documentsModify,
                    },
                },
            };

          saveSigns(finalConfiguration);
        } else {
            // --- Move to next step ---
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const saveSigns = async (finalConfiguration) => {
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("payload", JSON.stringify(finalConfiguration));
        data.append("docId", stepId);
        data.append("cicCfgId", formularioPrinId);
        const response = await axios.post(getApiUrl(window.location.origin) + "/Signs/saveSigns", data);
        if (response.data.success) {
        alertService.success(`<i class="fal fa-check-circle mr-1"></i>${response.data.message}`, {autoClose: true});
        } else {
        alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${response.data.message}`, {autoClose: true});
        }
    };

    const saveDisabledSigns = async () => {
        try {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("docId", stepId);
            data.append("signsConfIds", JSON.stringify(loadedSignIds));

            const response = await axios.post(getApiUrl(window.location.origin) + "/Signs/deleteSigns", data);
            if (response.data.success) {
                alertService.success(`<i class="fal fa-check-circle mr-1"></i>${response.data.message}`, { autoClose: true });
                resetSignsState();
            } else {
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${response.data.message}`, { autoClose: true });
            }
        } catch (error) {
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>No se pudieron eliminar las firmas`, { autoClose: true });
        }
    };

    const handleBack = () => {
        setStep2Attempted(false);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSignChange = (selectedOption) => {
        const signsEnabled = selectedOption.value === '1';
        if (signsEnabled) {
            setPendingDisableSave(false);
            setHasSign(true);
            return;
        }

        const shouldShowDisableSave = hadSignsLoaded && loadedSignIds.length > 0;
        if (shouldShowDisableSave) {
            setPendingDisableSave(true);
            setHasSign(false);
            return;
        }
        resetSignsState();
    }

    return (
        <>
            <MiSelect
                estadoForm={"enabled"}
                val={hasSign ? "1" : "0"}
                loading={onLoading}
                id={"has_sign"}
                name={"has_sign"}
                label={"Habilitar firmas"}
                formulario={stepId}
                placeholder={"Permitir firmar"}
                col={4}
                isClearable={false}
                isSearchable={false}
                dataType={"codigo"}
                data={[{ value: "1", label: "Sí" }, { value: "0", label: "No" }]}
                required={true}
                change={handleSignChange}
            />

            {pendingDisableSave && (
                <div style={{ marginTop: '12px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={saveDisabledSigns}
                        disabled={!stepId || loadedSignIds.length === 0}
                    >
                        Eliminar firmas
                    </Button>
                </div>
            )}

            {hasSign && (
                <Card className={classes.root} style={{ marginTop: '20px' }}>
                    <CardContent>
                        <div className={classes.instructions}>{getStepContent(activeStep)}</div>
                        <div>
                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                className={classes.button}
                            >
                                Anterior
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                className={classes.button}
                            >
                                {activeStep === steps.length - 1 ? 'Finalizar' : 'Siguiente'}
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            )}
        </>
    );
}

export default Signs;